'use es6';

import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StepInterface from './StepInterface';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { POST_SETUP_STEP, FAILURE_STEP, TEST_MESSAGE_STEP } from '../../constants/InboxConnectStepKeys';
import TestMessageSteps from '../../constants/TestMessageSteps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TestMessageStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      message: ''
    };
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(TEST_MESSAGE_STEP);
    this.startTest();
  }
  startTest() {
    const {
      emailAddress,
      service,
      setShownStep,
      setConnectError
    } = this.props;
    const testSucceeded = () => setShownStep(POST_SETUP_STEP);
    const testFailed = error => this.getInbox().then(inbox => {
      if (!inbox.error_type && !inbox.error_message) setConnectError(error && error.message);else setConnectError({
        error_type: inbox.error_type,
        error_message: inbox.error_message
      });
    })
    // If we can't get the facsimile inbox - at least
    // set the test message error so we have something
    .catch(() => setConnectError(error && error.message)).finally(() => setShownStep(FAILURE_STEP));
    TestMessageSteps.reduce((testChain, step) => testChain.then(stepData => {
      this.setState({
        message: step.message
      });
      return step.operation(service, stepData);
    }), Promise.resolve(emailAddress)).then(testSucceeded).catch(testFailed);
  }
  getInbox() {
    const {
      emailAddress,
      service
    } = this.props;
    return service.getFacsimileInboxByEmail(emailAddress);
  }
  render() {
    const {
      message
    } = this.state;
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100%",
      children: /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        "data-selenium": "test-message-step",
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: 100
        }), /*#__PURE__*/_jsx("p", {
          children: message && /*#__PURE__*/_jsx(FormattedMessage, {
            message: message
          })
        })]
      })
    });
  }
}
TestMessageStep.propTypes = StepInterface;
export default TestMessageStep;